import { data } from '../../svg/Recycling/data';
import { makeIcon } from '../makeIcon';

export const Recycling = makeIcon(data, 'recycling', 'Recycling');

export default Recycling;
